export const paginate = (array, size, page) => {
  return array.slice((page - 1) * size, page * size);
};

export const getTotalPages = (total, size) => {
  return Math.ceil(total / size);
};

export const waitFor = (variable, callback) => {
  const interval = window.setInterval(() => {
    if (window[variable]) {
      window.clearInterval(interval);
      callback();
    }
  }, 200);
};

export const waitForElm = selector => {
  return new Promise(resolve => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new window.MutationObserver(mutations => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
};

export const stripHTML = html => {
  const tmp = document.createElement('DIV');
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || '';
};

export const convertToSlug = Text =>
  Text.toLowerCase()
    .replace(/[^\w ]+/g, '')
    .replace(/ +/g, '-');

export const isInViewport = elem => {
  const distance = elem.getBoundingClientRect();
  return (
    distance.top >= 0 &&
    distance.left >= 0 &&
    distance.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    distance.right <=
      (window.innerWidth || document.documentElement.clientWidth)
  );
};

export const initBorderAnimation = element => {
  const statsCircle = element.closest('.the-outcome-v2__stats-circle');
  statsCircle.querySelector('circle').classList.add('animate-circle');
};

export const getIsMobile = () =>
  window.matchMedia('(max-width: 1024px)').matches;
